export const SOCKET_CONNECTED = "socketConnected";
export const SOCKET_DESTROY = "socketDestroyed";